import { FETCH_PROFILE, FETCH_PROFILE_SUCCESS, FETCH_PROFILE_FAILED, EDIT_PROFILE, EDIT_PROFILE_SUCCESS, EDIT_PROFILE_FAILED, SESSION_EXPIRED_RESET } from '../actions/types';

const profile = (state = { status: undefined, editStatus: undefined, userDetails: {}, updatedProfile: {}, failedUsers: '' }, action) => {
  switch (action.type) {
    case FETCH_PROFILE:
      return Object.assign({}, state, { status: 'fetching' });
    case FETCH_PROFILE_SUCCESS:
      return Object.assign({}, state, { status: 'success', userDetails: action.data });
    case FETCH_PROFILE_FAILED:
      return Object.assign({}, state, { status: 'failed', failedUsers: action.data });
    case EDIT_PROFILE:
      return Object.assign({}, state, { editStatus: 'updating' });
    case EDIT_PROFILE_SUCCESS:
      return Object.assign({}, state, { editStatus: 'success', updatedProfile: action.data });
    case EDIT_PROFILE_FAILED:
      return Object.assign({}, state, { editStatus: 'failed', failedUsers: action.data });
    case SESSION_EXPIRED_RESET:
      return Object.assign({}, state, { status: 'session', failedUsers: '' });
    default:
      return state;
  }
};

export default profile;
